/* src/app/shared/contract/contract-item/contract-thema-nego/thema-list-pack-dialog/thema-list-pack-dialog.component.scss */
.mat-title {
  color: #001A33;
}
.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 1000px;
  height: 530px;
  margin: 0;
  padding: 25px;
  overflow-y: auto;
}
.title-container {
  justify-content: flex-start;
  font: 700 16px FranceTV Brown;
}
.options-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}
.options-container .search-container {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.pack-list-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 20px;
  height: 100%;
  padding: 20px;
  border-radius: 5px;
  background-color: rgba(36, 70, 102, 0.05);
}
.pack-list-container .pack-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
  height: fit-content;
  min-height: 60px;
  padding: 15px 20px;
  border-radius: 5px;
  background-color: #FFF;
}
.pack-list-container .pack-container .pack-infos {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 25px;
  font: 400 14px FranceTV Brown;
  color: #001A33;
}
.pack-list-container .pack-container .pack-infos .pack-label {
  width: 100px;
}
.pack-list-container .pack-container .pack-channels {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  padding: 5px;
  width: 100%;
}
.pack-list-container .pack-container .pack-channels .channel-infos {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  width: 22%;
  gap: 5px;
  font: 400 12px FranceTV Brown;
  color: #001A33;
}
.pack-list-container .pack-container .pack-channels .channel-infos .channel-logo {
  height: 14px;
}
.pack-list-container .pack-container .pack-channels .channel-infos .channel-separator {
  font: 300 12px FranceTV Brown;
  color: #6B90B3;
}
.pack-list-container .pack-container .pack-channels .more-channels {
  justify-content: center;
}
.pack-list-container .pack-container .pack-channels .more-channels :hover {
  cursor: pointer;
}
.pack-list-container .pack-container .pack-actions {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
  gap: 25px;
}
.pack-list-container .pack-container .pack-actions mat-icon {
  cursor: pointer;
  height: 20px;
}
.pack-list-container .pack-container .pack-actions .delete-action-icon {
  color: #F03C64;
}
.loader-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
}
.mat-dialog-container {
  border-radius: 25px;
}
/*# sourceMappingURL=thema-list-pack-dialog.component.css.map */
